import type { FC } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { PerformerInfoCardDesktop } from "./PerformerInfoCardDesktop";
import { PerformerInfoCardMobile } from "./PerformerInfoCardMobile";

interface Props {
  showOnlyImage?: boolean;
}

/**
 * Card to display information about a performer such as name, bio, social media links, etc.
 */
export const PerformerInfoCard: FC<Props> = ({ showOnlyImage }) => {
  const isMobile = !useMediaQuery(Breakpoint.Tablet);
  if (!isMobile) {
    return <PerformerInfoCardDesktop showOnlyImage={showOnlyImage} />;
  }
  return <PerformerInfoCardMobile />;
};
